export const PDP_TRADE_ONBOARDING_VIEW_COUNT_STORAGE_KEY = 'pdpTradeOnboarding_localStorageKey';
export const SB_TRADE_ONBOARDING_VIEW_COUNT_STORAGE_KEY = 'sbTradeOnboardingViewCount';
export const TRADE_ONBOARDING_TYPE_PDP = 'TRADE_ONBOARDING_TYPE_PDP';
export const TRADE_ONBOARDING_TYPE_SB = 'TRADE_ONBOARDING_TYPE_SB';
